export default __webpack_public_path__ + "static/O5-lieutenant-colonel-e1cafa811e3297c411d3cffb0b8d893d.png";